import React, { Component } from 'react';

import { FormEdit } from 'Components/FormEdit';
import IntInput, { normalizeInt } from 'Components/inputs/Integer';
import TextInput from 'Components/inputs/Text';
import Date from 'Components/inputs/Date';
import ImageInput from '../../../images/Input';
import AgentInput from '../../agents/Input';
import SelectConstant from 'FDComponents/constants/Select';
import AreaInput from 'FDComponents/areas/Input';
import { AgentCompanySelect } from '../../../agentCompanies/components/AgentCompanySelect';
import Float from 'Components/inputs/Float';

export default class Form extends Component {
  config = {
    fields: [
      'id',
      'firstName',
      'shortFirstName',
      'lastName',
      'shortLastName',
      'nickName',
      'matchName',
      'marketValue',
      'role',
      'gender',
      'birthDate',
      'placeOfBirth',
      'foot',
      'size',
      'weight',
      'twitterLink',
      'facebookLink',
      'instagramLink',
      'websiteLink',
      'priority',
      'position',
      'positionSide',
      'metaImportGSMUuid',
      'footballManagerUuid',
    ],
    objectFields: ['birthCountry', 'mainNationality', 'secondNationality', 'portrait', 'agent', 'agentCompany'],
    disposition: [
      {
        size: 3,
        fields: [{ name: 'portrait', component: ImageInput }],
      },
      {
        size: 9,
        fields: [
          { name: 'firstName', component: TextInput },
          { name: 'shortFirstName', component: TextInput },
          { name: 'lastName', component: TextInput },
          { name: 'shortLastName', component: TextInput },
          { name: 'matchName', component: TextInput },
          { name: 'nickName', component: TextInput },
        ],
      },
      {
        title: '',
        fields: [
          {
            name: 'role',
            component: SelectConstant,
            entity: 'person',
            size: 6,
          },
          {
            name: 'gender',
            component: SelectConstant,
            entity: 'person',
            size: 6,
            disabled: true,
          },
          { name: 'birthDate', component: Date, size: 6 },
          { name: 'placeOfBirth', component: TextInput, size: 6 },
          { name: 'birthCountry', component: AreaInput, size: 6 },
          { name: 'mainNationality', component: AreaInput, size: 6 },
          { name: 'secondNationality', component: AreaInput, size: 6 },
          {
            name: 'priority',
            component: IntInput,
            normalize: normalizeInt,
            size: 6,
          },
          { name: 'metaImportGSMUuid', component: TextInput, size: 6 },
          { name: 'footballManagerUuid', component: TextInput, size: 6 },
        ],
      },
      {
        size: 6,
        title: 'form_socialLinks',
        fields: [
          {
            name: 'facebookLink',
            component: TextInput,
            hintText: 'https://www.facebook.com/user',
          },
          {
            name: 'twitterLink',
            component: TextInput,
            hintText: 'https://twitter.com/user',
          },
          {
            name: 'instagramLink',
            component: TextInput,
            hintText: 'https://instagram.com/user',
          },
          {
            name: 'websiteLink',
            component: TextInput,
            hintText: 'http://www.link.com',
          },
        ],
      },
      {
        size: 6,
        title: 'form_infoPlayer',
        fields: [
          { name: 'foot', component: SelectConstant, entity: 'person' },
          { name: 'position', component: SelectConstant, entity: 'person' },
          { name: 'positionSide', component: SelectConstant, entity: 'person' },
          { name: 'size', component: IntInput, normalize: normalizeInt },
          { name: 'weight', component: IntInput, normalize: normalizeInt },
          { name: 'marketValue', component: Float },
          { name: 'agent', component: AgentInput },
          { name: 'agentCompany', component: AgentCompanySelect },
        ],
      },
    ],
  };

  render() {
    const { data, onSubmit } = this.props;

    return (
      <FormEdit
        key={data.id}
        form={`player_${data.id}`}
        onSubmit={onSubmit}
        data={data}
        config={this.config}
        main
        useUserRestriction
      />
    );
  }
}
